import {
  PatientFilterState,
  ReportFilterState,
} from "src/components/manufacturer/reportFilters/types";
import {
  ActionRequiredProps,
  CoverageAvailableProps,
  PendingDataProps,
  sp_treatments_data,
} from "../actionDashboard/types";
import { ReportListingProps } from "src/context/authContext/types";

export type ReportsResponseDataType = {
  coverage_available: CoverageAvailableProps;
  action_required: ActionRequiredProps;
  specialty_pharmacy: {
    sp_treatments_data: sp_treatments_data[];
    page_count: number;
    dpn_count: number;
  };
  pending: PendingDataProps;
  doctor_dropdown: { id: number; name: string }[];
  practice_dropdown: { id: number; name: string }[];
};
export type reportsResponseDataType = {
  report_data: report_data;
};
export type ReportResponseType = {
  code: number;
  message: string;
  data: reportsResponseDataType | ReportsResponseDataType;
};

export type report_data = {
  "RBD NAME"?: string;
  "SAM NAME"?: string;
  "FAM NAME"?: string;
  "KAM Name"?: string;
  "Case ID": number;
  "Global Patient": number;
  "Case Received": null | string;
  "Transfer Created": null | string;
  "Doctor Name": string;
  Practice: string;
  Status: string;
  "Date Xfer to SP selected by office": string;
  "Rx PA Status": string;
  "Rx PA Status Date": null | string;
  "Sub status": null | string;
  "Sub Status date": null | string;
  "Pharmacy Name": string;
  "External Status": null | string;
  "Ship Date": null | string;
  "Tracking Company": null | string;
  "Tracking Number": null | number;
  Outcome: string;
  status_reason: string;
  Ongoing: string;
  "Practice Name": string;
};

export type ReportFilterProps = ReportFilterState & {
  report_name: string;
  file_required: boolean;
};
export enum PatientFilterStateActions {
  SET_QUERY_PARAMS = "setQueryParams",
  SET_REF_USER = "setRefUser",

  CHANGE_TREATABLE_PAGE = "changeTreatablePage",
  CHANGE_TODO_PAGE = "changeTodoPage",
  CHANGE_SP_TREATMENT_PAGE = "changeSPTreatmentPage",
  CHANGE_NOT_TREATED_PAGE = "changeNotTreatedPage",
  CHANGE_USER_ROLE_AND_ID = "changeUserRoleAndId",
  CHANGE_REPORT_NAME = "changeReportName",
}

export enum ReportFilterStateActions {
  SET_QUERY_PARAMS = "setQueryParams",
  SET_REF_USER = "setRefUser",
  CHANGE_PAGE = "changePage",
  CHANGE_PAGINATION_BIT = "changePaginationBit",
  CHANGE_REPORT_NAME = "changeReportName",
}

export type ReportFilterStateActionsType =
  {
    type: ReportFilterStateActions.SET_QUERY_PARAMS;
    payload: Partial<ReportFilterState>;
  }
  | {
      type: ReportFilterStateActions.SET_REF_USER;
      payload: string;
    }
  | {
      type: ReportFilterStateActions.CHANGE_REPORT_NAME;
      payload: string;
    }
  | {
      type: ReportFilterStateActions.CHANGE_PAGE;
      payload: number;
    }
  | {
      type: ReportFilterStateActions.CHANGE_PAGINATION_BIT;
      payload: boolean;
    };

export type ActionStatisticsDashboardActionType =
  | {
      type: PatientFilterStateActions.SET_QUERY_PARAMS;
      payload: Omit<
        Omit<
          Omit<Omit<PatientFilterState, "treatable_page">, "todo_page">,
          "sp_treatment_page"
        >,
        "not_treated_page"
      >;
    }
  | {
      type: PatientFilterStateActions.SET_REF_USER;
      payload: string;
    }
  | {
      type: PatientFilterStateActions.CHANGE_TREATABLE_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_TODO_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_SP_TREATMENT_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_NOT_TREATED_PAGE;
      payload: number;
    }
  | {
      type: PatientFilterStateActions.CHANGE_USER_ROLE_AND_ID;
      payload: { role: string; id: string; user_ref: string };
    }
  | {
      type: PatientFilterStateActions.CHANGE_REPORT_NAME;
      payload: string;
    };


export const REPORT_DISPLAY_NAMES: Record<keyof ReportListingProps, string> = {
  "Field Liaison Report": "field_liaison_report",
  "Full Report": "full_report",
  "Incoming Fax Report": "incoming_fax_report",
  "Login Report": "login_report",
  "Status Report": "status_report",
  "Refill Report": "refill_report",
  // "Pre Condensed Sales Report": "pre_condensed_sales_report",
  // "Pre Refill Report": "pre_refill_report",
  // "New Full Report": "new_full_report",
  // "Old Full Report": "old_full_report",
  "Condensed Sales Report": "condensed_sales_report",

};

export const REPORT_TITLES: Record<string, keyof ReportListingProps> = {
  field_liaison_report: "Field Liaison Report",
  full_report: "Full Report",
  incoming_fax_report: "Incoming Fax Report",
  login_report: "Login Report",
  status_report: "Status Report",
  refill_report: "Refill Report",
  // pre_condensed_sales_report: "Pre Condensed Sales Report",
  // pre_refill_report: "Pre Refill Report",
  // new_full_report: "New Full Report",
  // old_full_report: "Old Full Report",
  condensed_sales_report: "Condensed Sales Report",
};


